// Matches the confirmed `/super-admin/payouts` response shape.
export interface PayoutRequest {
  id: number;
  user_id: number;
  user_email: string;
  user_first_name: string;
  user_last_name: string;
  image_url?: string | null;
  wallet_balance: number;
  bank_account_id: number;
  bank_name: string;
  // Full, unmasked account number — mask it client-side with `maskAccountNumber()`
  // before displaying (the API does not pre-mask it).
  account_number: string;
  account_name: string;
  amount: number;
  reference: string;
  rejection_reason: string | null;
  failure_reason: string | null;
  requested_at: string;
  reviewed_at: string | null;
  completed_at: string | null;
  status: "pending" | "approved" | "rejected";
}

// Builds a ui-avatars fallback URL keyed on the recommender's full name, so the
// generated initials actually track who the payout belongs to.
export const getPayoutAvatarUrl = (payout: Pick<PayoutRequest, "user_first_name" | "user_last_name">): string =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(
    `${payout.user_first_name || ""} ${payout.user_last_name || ""}`.trim()
  )}&background=111&color=fff`;

export interface PayoutStats {
  pending_requests_count: number;
  pending_requests_amount: number;
  approved_today_count: number;
  rejected_today_count: number;
}

export interface PayoutRequestsResponse {
  status: boolean;
  message: string;
  payouts: PayoutRequest[];
  page?: number;
  page_size?: number;
  total_pages?: number;
  total?: number;
}

export interface RejectionReason {
  value: string;
  label: string;
  description: string;
}

export const REJECTION_REASONS: RejectionReason[] = [
  {
    value: "large_amount",
    label: "Large Payout Amount",
    description: "Request exceeds the manual approval threshold.",
  },
  {
    value: "suspicious_activity",
    label: "Suspicious or unusual activity detected",
    description: "Activity has been flagged for additional verification.",
  },
  {
    value: "account_review",
    label: "Account under review",
    description: "The account is currently being reviewed and payouts are temporarily paused.",
  },
  {
    value: "other",
    label: "Other",
    description: "Specify a custom reason in the notes below.",
  },
];
